import React from 'react';
import { Image } from 'react-bootstrap';
import Button from './Button';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../css/Shared/GenericReusableModal.css';
import RespModal from './RespModal';

function GenericReusableModal(props) {
    return (
        <RespModal hasOpen={props.hasOpen}>
            <div className="modalsizeGenericReusableModal" >
                {props.showImage &&
                    <>
                        <Image src={props.showImagesrc} /><br /><br />
                    </>
                }
                <div class="GenericReusableModalHeading">{props.modalHeading}</div>
                <div id="modalcontainsuccessGenericReusableModal">
                    {props.children}
                </div>
                <div class="GenericReusableModalbuttonouter">
                    <Button
                        id="cancelresploginbuttoGenericReusableModal"
                        type="button"
                        class="btn btn-dark"
                        onClick={props.onCloseModal}
                    >{props.buttonLabel}
                    </Button>
                </div>
            </div>
        </RespModal>
    );
}
export default GenericReusableModal;
